import { render, staticRenderFns } from "./AboutTask.vue?vue&type=template&id=58bcb672&scoped=true"
import script from "./AboutTask.vue?vue&type=script&lang=js"
export * from "./AboutTask.vue?vue&type=script&lang=js"
import style0 from "./AboutTask.vue?vue&type=style&index=0&id=58bcb672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bcb672",
  null
  
)

export default component.exports